import Above from 'components/breakpoints/Above';
import AspectWrapper from 'components/wrappers/AspectWrapper';
import Below from 'components/breakpoints/Below';
import CmsBlocks from 'libs/wordpress/content/CmsBlocks';
import ColumnsLayout from 'components/contentLayouts/ColumnsLayout';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import colors from 'config/theme/colors';
import { mediaQueries } from 'config/theme/breakpoints';
import moduleMargins from 'config/theme/moduleMargins';
import { moduleSettingsProp } from 'utils/proptypes/modules/settingsProps';
import ratios from 'config/theme/ratios';

const TwoColumnsLayout = ({ content = {}, last = false, settings = {}, ...rest }) => {
    const {
        background_color: backgroundColor,
        switch_column_order: switchColumnOrder,
        text_color: textColor,
    } = settings;

    const { columns } = content;

    // We should not render the two column if the data is not correct.
    if (columns.length !== 2) {
        return null;
    }

    return (
        <MaxWidthWrapper
            includeContentMargins
            as="section"
            backgroundColor={backgroundColor}
            borderBottom={!last ? `1px solid ${colors.black}` : null}
            py={moduleMargins.md}
        >
            <ColumnsLayout
                blocks={columns.map((column, index) => (
                    <div
                        key={`${column.layout}-${index}`}
                        order={switchColumnOrder && index === 0 ? [1, null, null, 2] : 1}
                    >
                        <Below
                            breakpoint="md"
                            render={() => (
                                <div>
                                    <CmsBlocks
                                        isColumn
                                        data={column}
                                        mediaQuery={mediaQueries.twoColumn}
                                        moduleTextColor={textColor}
                                        {...rest}
                                    />
                                </div>
                            )}
                        />
                        <Above
                            breakpoint="md"
                            render={() => (
                                <AspectWrapper ratio={ratios.verticalWide}>
                                    <CmsBlocks
                                        isColumn
                                        data={column}
                                        mediaQuery={mediaQueries.twoColumn}
                                        moduleTextColor={textColor}
                                        {...rest}
                                    />
                                </AspectWrapper>
                            )}
                        />
                    </div>
                ))}
                columnSizes={[12, null, null, 6]}
                gutterHeight={[16, null, 24]}
            />
        </MaxWidthWrapper>
    );
};

TwoColumnsLayout.propTypes = {
    content: PropTypes.object,
    last: PropTypes.bool,
    settings: moduleSettingsProp,
};

export default TwoColumnsLayout;
